(() => {
  if (customElements.get('skinclub-points')) return;
  const money = n => new Intl.NumberFormat('da-DK', {style:'currency',currency:'DKK'}).format(n/100);
  const points = n => new Intl.NumberFormat('da-DK',{maximumFractionDigits:2}).format(n/100);
  class SkinClubPoints extends HTMLElement {
    async connectedCallback() {
      if(this.initialized) return; this.initialized=true;
      this.innerHTML=`<section class="sc-points"><p class="sc-points-balance">Henter din saldo…</p><div class="sc-points-controls" hidden><div class="sc-points-value"><label><input aria-label="Point du vil bruge" class="sc-points-number" type="number" min="0" step="1" value="0" inputmode="numeric"></label><strong class="sc-points-saving">−0,00 kr.</strong></div><label class="sc-points-range-label">Vælg antal point<input class="sc-points-range" type="range" min="0" max="0" step="100" value="0"></label><div class="sc-points-limits"><span class="sc-points-available"></span></div><button type="button" class="sc-points-apply" disabled>Brug point</button></div><button type="button" class="sc-points-remove" hidden>Fjern point</button><p class="sc-points-status" role="status" aria-live="polite"></p></section>`;
      this.range=this.querySelector('input[type=range]');this.number=this.querySelector('input[type=number]');this.button=this.querySelector('.sc-points-apply');
      this.range.addEventListener('input',()=>this.select(Number(this.range.value)));
      this.number.addEventListener('input',()=>this.select(Math.round(Number(this.number.value)*100),false));
      this.number.addEventListener('change',()=>this.select(this.selected));
      this.button.addEventListener('click',()=>this.apply());
      this.removeButton=this.querySelector('.sc-points-remove');
      this.removeButton.addEventListener('click',()=>this.cancelPoints());
      await this.load();
    }
    disconnectedCallback(){clearTimeout(this.cancelTimer);}
    select(value,updateNumber=true) {
      this.selected=Math.max(0,Math.min(this.maximum,Number.isFinite(value)?Math.floor(value/100)*100:0));
      this.range.value=String(this.selected);if(updateNumber)this.number.value=String(this.selected/100);
      this.range.style.setProperty('--fill',`${this.maximum?this.selected/this.maximum*100:0}%`);
      this.querySelector('.sc-points-saving').textContent=`−${money(this.selected)}`;
      this.range.setAttribute('aria-valuetext',`${points(this.selected)} point, spar ${money(this.selected)}`);
      this.button.textContent=this.selected?`Brug ${points(this.selected)} point`:'Brug point';
      this.button.disabled=this.busy||!this.selected||!this.enabled;
    }
    async load() {
      try {
        if(this.hasAttribute('data-preview')) {
          if(!['127.0.0.1','localhost'].includes(location.hostname)) throw Error('unavailable');
          this.quote={balanceMinor:18450,maximumMinor:18450,enabled:true,preview:true};
        } else {
          const root=window.Shopify?.routes?.root || '/';
          const cartResponse=await fetch(root+'cart.js',{cache:'no-store'});if(!cartResponse.ok)throw Error('unavailable');
          const cart=await cartResponse.json();this.cart=cart;
          const response=await fetch(root+'apps/skinclub-circle/quote',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:cart.items.map(x=>({variantId:String(x.variant_id),quantity:x.quantity})),currency:cart.currency}),cache:'no-store'});
          if(response.status===401)throw Error('login');
          const payload=await response.json();
          if(!response.ok)throw Error(payload.error==='mapping_required'?'mapping':payload.error==='identity_review'?'mapping':'unavailable');this.quote=payload;
        }
        if(!Number.isSafeInteger(this.quote.balanceMinor)||!Number.isSafeInteger(this.quote.maximumMinor)||this.quote.maximumMinor<0)throw Error('unavailable');
        if(this.quote.pending){
          this.pending=this.quote.pending;
          this.querySelector('.sc-points-balance').textContent=`Du har ${points(this.quote.balanceMinor)} point tilbage`;
          if(this.pending.state==='cancel_pending'){this.status('Pointvalget fjernes. Tilbageførsel kontrolleres — det kan tage op til 2 minutter.');this.cancelPoints();return;}
          if(this.pending.state==='active'){
            this.removeButton.hidden=false;
            this.querySelector('.sc-points-controls').hidden=false;
            this.querySelector('.sc-points-value').hidden=true;this.querySelector('.sc-points-range-label').hidden=true;this.querySelector('.sc-points-limits').hidden=true;
            const applied=this.cart?.discount_codes?.some(x=>x.code?.toUpperCase()===this.pending.code?.toUpperCase()&&x.applicable);
            this.button.disabled=!!applied;this.button.textContent=applied?`${points(this.pending.amountMinor)} point anvendt`:`Anvend dine valgte ${points(this.pending.amountMinor)} point`;
            this.status(applied?'Din pointrabat er medregnet. Du kan fjerne pointvalget igen.':'Pointene er allerede trukket og gemt til dit køb. Du bliver ikke trukket igen, hvis du fortsætter senere.');
          }else this.status('Dit pointvalg bliver afklaret. Forsøg ikke at indløse igen. Kontakt SkinClub, hvis du har brug for hjælp.');
          return;
        }
        // An authoritative quote without a pending redemption invalidates old point codes.
        // Preserve unrelated discount codes and recalculate the actual Shopify cart.
        if(!this.quote.pending && this.cart?.discount_codes?.some(x=>/^SC-[A-F0-9]{32}$/i.test(x.code||''))) {
          this.status('Opdaterer kurven efter det annullerede pointvalg…');
          if(!SkinClubPoints.cleanup) SkinClubPoints.cleanup=this.clearReleasedCodes();
          await SkinClubPoints.cleanup;
          location.reload();
          return;
        }
        this.maximum=Math.floor(Math.min(Math.max(0,this.quote.balanceMinor),this.quote.maximumMinor)/100)*100;this.enabled=this.quote.enabled===true;
        this.querySelector('.sc-points-balance').textContent=`Du har ${points(this.quote.balanceMinor)} point`;
        this.range.max=String(this.maximum);this.number.max=String(this.maximum/100);
        this.querySelector('.sc-points-available').textContent=`Du har ${points(this.quote.balanceMinor)} point`;
        this.querySelector('.sc-points-balance').hidden=true;
        this.querySelector('.sc-points-controls').hidden=false;this.select(0);
        if(!this.enabled)this.status('Point kan ikke anvendes på denne kurv lige nu.');
        else this.status('');
      } catch(e) {
        this.querySelector('.sc-points-balance').textContent=e.message==='login'?'Log ind for at bruge dine point':'Saldoen kunne ikke hentes';
        if(e.message==='login') {
          const a=document.createElement('a');a.href=(window.Shopify?.routes?.root||'/')+'customer_authentication/login?return_to='+encodeURIComponent('/cart');a.textContent='Log ind';this.querySelector('.sc-points-status').replaceChildren(a);
        }else this.status(e.message==='mapping'?'Din konto er endnu ikke tilknyttet en pointkonto. Kontakt SkinClub, hvis du har point fra tidligere køb.':'Prøv igen om lidt. Du kan stadig købe uden point.');
      }
    }
    status(text){this.querySelector('.sc-points-status').textContent=text;}
    async clearReleasedCodes() {
      const root=window.Shopify?.routes?.root || '/';
      const keep=this.cart.discount_codes.filter(x=>!/^SC-[A-F0-9]{32}$/i.test(x.code||'')).map(x=>x.code);
      const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:keep.join(',')})});
      if(!response.ok)throw Error('cart_cleanup_failed');
      const cart=await response.json();
      if(cart.discount_codes?.some(x=>/^SC-[A-F0-9]{32}$/i.test(x.code||'')))throw Error('cart_cleanup_failed');
    }
    async cancelPoints() {
      if(this.cancelling||!this.pending?.id)return;
      this.cancelling=true;this.removeButton.disabled=true;this.button.disabled=true;
      this.status('Fjerner pointvalget og kontrollerer tilbageførsel…');
      try {
        const root=window.Shopify?.routes?.root || '/';
        const response=await fetch(root+'apps/skinclub-circle/cancel',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({checkoutId:this.pending.id})});
        const result=await response.json();
        if(!response.ok){
          this.status(result.error==='points_already_ordered'?'Pointene er knyttet til en ordre og kan ikke fjernes her.':result.error==='cancellation_review_required'?'Tilbageførslen skal kontrolleres af SkinClub. Pointene bliver ikke tilbageført flere gange.':'Pointvalget kunne ikke fjernes lige nu. Prøv igen om lidt.');
          this.removeButton.disabled=false;return;
        }
        if(result.state==='cancelled'){
          await this.clearReleasedCodes();location.reload();return;
        }
        if(result.state!=='cancelling')throw Error('unexpected_state');
        // Coupon is already expired. Refresh displayed totals while Gecko credit
        // waits for in-flight order checks, without starting a new redemption.
        if(this.cart?.discount_codes?.some(x=>/^SC-[A-F0-9]{32}$/i.test(x.code||''))){await this.clearReleasedCodes();location.reload();return;}
        this.removeButton.hidden=true;
        this.status('Pointvalget er fjernet. Saldoen opdateres automatisk — det kan tage op til 2 minutter.');
        this.cancelTimer=setTimeout(()=>{if(this.isConnected)this.cancelPoints();},15000);
      }catch{
        this.status('Vi kunne ikke bekræfte tilbageførslen. Genindlæs kurven for at se status.');this.removeButton.disabled=false;
      }finally{this.cancelling=false;}
    }
    async applyCode(code) {
      const root=window.Shopify?.routes?.root || '/';
      const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:code})});
      if(!response.ok)throw Error('cart_update_failed');
      const cart=await response.json();
      if(!cart.discount_codes?.some(x=>x.code.toUpperCase()===code.toUpperCase() && x.applicable))throw Error('discount_not_applicable');
      location.reload();
    }
    async apply() {
      if(this.busy)return;
      if(this.quote.preview){this.status(`Forhåndsvisning: ${points(this.selected)} point valgt. Ingen point er trukket.`);return;}
      if(!this.pending&&(!this.enabled||!this.selected))return;
      this.busy=true;this.button.disabled=true;
      try {
        if(this.pending?.state==='active'){await this.applyCode(this.pending.code);return;}
        const root=window.Shopify?.routes?.root || '/';
        this.status('Kontrollerer saldo og anvender dine point…');
        const response=await fetch(root+'apps/skinclub-circle/redeem',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({intent:this.quote.intent,amountMinor:this.selected})});
        const result=await response.json();
        if(!response.ok||result.state!=='active'||!result.code)throw Error('redemption_unconfirmed');
        this.pending=result;
        await this.applyCode(result.code);
      }catch {
        this.status(this.pending?.state==='active'?'Dine valgte point er gemt, men rabatten kunne ikke anvendes på denne kurv. Opdatér kurven eller kontakt SkinClub. Pointene bliver ikke trukket igen.':'Vi kunne ikke bekræfte indløsningen. Genindlæs siden for at se status. Bekræft ikke et nyt pointvalg.');
      }finally{this.busy=false;this.button.disabled=true;}
    }
  }
  customElements.define('skinclub-points',SkinClubPoints);
})();
